const certifications = [
    {
        "id": "1",
        "no": "1001",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase": "documentCheck",
        "activity": "documentCheck_S080",
        "operatorNo": "1103",
        "operatorName": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "identityType": "individual",
        "formType": ["processing"],
        "region": "domestic",
        "type":  "initial",
        "appNo": "202100012",
        "processingUncompletedLists": [
            {
                "item": "certificationPlace",
                "complete": "complete",
                "description": "地址格式有誤"
            },
            {
                "item": "certificationProduct",
                "complete": "uncompleted",
                "description":
                    "(1)檢驗報告為該批次，最新的報告，供應商沒有新的農殘報告可以提供，提供伂橙自己送檢成品\"人蔘黃耆茶\"農殘檢驗報告" +
                    "(2)西洋蔘又稱粉光蔘，請看介紹說明\n" +
                    "(3)供應商僅有農殘檢驗報告，沒有重金屬和二氧化硫報告\n" +
                    "(4)提供進貨單"
            },
            {
                "item": "rawMaterial",
                "complete": "complete",
                "description": "需補充非有機原料審查"
            },
            {
                "item": "survey_1",
                "complete": "uncompleted",
                "description": "請提供正確的設備路線圖檔案"
            },
            {
                "item": "survey_3",
                "complete": "uncompleted",
                "description": "請詳細說明維護有機完整性之防範說明"
            }
        ]
    },
    {
        "id": "2",
        "no": "2001",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase": "documentCheck",
        "activity": "documentCheck_S080",
        "operatorNo": "1107",
        "operatorName": "複雜生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "US",
                "category": ["crop", "handling"]
            },
            {
                "standard": "EU",
                "category": ["crop", "processing"]
            }
        ],
        "identityType": "individual",
        "formType": ["crop", "processing"],
        "region": "domestic",
        "type":  "initial",
        "appNo": "202100098",
        "processingUncompletedLists": [
            {
                "item": "certificationPlace",
                "complete": "complete",
                "description": "地址格式有誤"
            },
            {
                "item": "certificationProduct",
                "complete": "uncompleted",
                "description":
                    "(1)檢驗報告為該批次，最新的報告，供應商沒有新的農殘報告可以提供，提供伂橙自己送檢成品\"人蔘黃耆茶\"農殘檢驗報告" +
                    "(2)西洋蔘又稱粉光蔘，請看介紹說明\n" +
                    "(3)供應商僅有農殘檢驗報告，沒有重金屬和二氧化硫報告\n" +
                    "(4)提供進貨單"
            },
            {
                "item": "rawMaterial",
                "complete": "complete",
                "description": "需補充非有機原料審查"
            },
            {
                "item": "survey_1",
                "complete": "uncompleted",
                "description": "請提供正確的設備路線圖檔案"
            },
            {
                "item": "survey_3",
                "complete": "uncompleted",
                "description": "請詳細說明維護有機完整性之防範說明"
            }
        ],
        "cropUncompletedLists": [
            {
                "item": "cropManagement",
                "complete": "uncompleted",
                "description": "請提供正確的有害生物管理專家聯絡資訊"
            },
            {
                "item": "farmPlantInformation",
                "complete": "uncompleted",
                "description": "農場圖資訊有誤"
            }
        ]
    },
    {
        "id": "3",
        "no": "1001",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase": "documentReview",
        "activity": "documentReview_S30",
        "operatorNo": "1103",
        "operatorName": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "identityType": "individual",
        "formType": ["processing"],
        "region": "domestic",
        "type":  "initial",
        "appNo": "202100012",
        "supplementDeadline": "2021-10-22",
        "processingUncompletedLists": [
            {
                "item": "rawMaterial",
                "complete": "uncompleted",
                "description": "原料有使用非有機且交代不清楚"
            },
            {
                "item": "survey_5",
                "complete": "uncompleted",
                "description": "沒有完全符合基準要求"
            }
        ],
    },
    {
        "id": "4",
        "no": "1001",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase": "inspection",
        "activity": "inspection_S20",
        "operatorNo": "1103",
        "operatorName": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "identityType": "individual",
        "formType": ["processing"],
        "certificationType": "processing",
        "region": "domestic",
        "type":  "initial",
        "appNo": "202100012",
        "ncrs": [
            {
                "carNo": "CAR048-01",
                "observation": "當有機生產區緊臨慣行生產、公路等污染源時，無法在有機生產區設立足以阻絶污染的緩衝帶或障礙物，以防止有機生產區受污染",
                "regulationNo": "2-13",
                "checklistType": "crop",
                "checklistNos": [
                    {
                        "section": "01",
                        "checklistNo": ["01-5", "01-3"]
                    },
                    {
                        "section": "03",
                        "checklistNo": ["03-1", "03-3"]
                    },
                ]
            },
            {
                "carNo": "CAR048-02",
                "observation": "具有管理中心品質管理系統文件、相關作業程序及執行記錄，如組織架構、職掌、規定及內部成員違規處置等敘述不明確",
                "regulationNo": "3-13",
                "checklistType": "group",
                "checklistNos": [
                    {
                        "section": "02",
                        "checklistNo": ["02-1", "02-3"]
                    },
                ]
            }
        ],
        "ncrHistories": [
            {
                "carNo": "CAR048-01",
                "observation": "當有機生產區緊臨慣行生產、公路等污染源時，無法在有機生產區設立足以阻絶污染的緩衝帶或障礙物，以防止有機生產區受污染",
                "regulationNo": "2-13",
                "estimatedImprovementDate": "2022-01-27T00:00:00.000+08:00",
                "correctionActionPlan": "設立足以阻絶污染的緩衝帶或障礙物，以防止有機生產區受污染",
                "reviewResult": "supplemented",
                "comment": "尚未補件完成",
                "attachments": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件1.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件2.pdf",
                        "lastModified": 0
                    }
                ]
            },
            {
                "carNo": "CAR048-02",
                "observation": "具有管理中心品質管理系統文件、相關作業程序及執行記錄，如組織架構、職掌、規定及內部成員違規處置等敘述不明確",
                "regulationNo": "3-13",
                "estimatedImprovementDate": "2022-01-30T00:00:00.000+08:00",
                "correctionActionPlan": "重新檢視各個相關作業程序之流程是否正確",
                "reviewResult": "uncompleted",
                "comment": "仍缺少單據",
                "attachments": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件3.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件4.pdf",
                        "lastModified": 0
                    }
                ]
            }
        ]
    },
    {
        "id": "5",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase":"improvementDeadline",
        "activity":"improvementDeadline_S10",
        "operatorNo": "1103",
        "operatorName": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "identityType": "individual",
        "formType": ["processing"],
        "certificationType": "processing",
        "region": "domestic",
        "type":  "initial",
        "appNo": "202100012",
        "ncrs": [
            {
                "observation": "未建立標章使用紀錄",
            },
            {
                "observation": "未保留資材-龍燈精鍊油採購單據"
            }
        ],
        "improvementDeadline": "2022-01-20T00:00:00.000+08",
        "supplementHistories": [
            {
                "improvedItem": "未建立標章使用紀錄",
                "checkDate": "2022-01-16T00:00:00.000+08",
                "checkResult": "reject",
                "comments": "請提供標章使用紀錄表",
                "customerReplyDate": "2022-01-18T00:00:00.000+08",
                "reply": "已提供"
            },
            {
                "improvedItem": "未保留有害生物防治資材使用紀錄",
                "checkDate": "2022-01-16T00:00:00.000+08",
                "checkResult": "approve",
                "customerReplyDate": "2022-01-18T00:00:00.000+08",
                "reply": "已提供"
            }
        ]
    },
    {
        "id": "6",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase": "",
        "activity": "violationDocReview_S20",
        "operatorNo": "1103",
        "operatorName": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "identityType": "individual",
        "formType": ["processing"],
        "certificationType": "processing",
        "region": "domestic",
        "type":  "followUp",
        "appNo": "202100024",
        "reviewHistories": [
            {
                "reviewDate": "2021-09-20T00:00:00.000+08",
                "description": "未交代農藥用處"
            },
            {
                "reviewDate": "2021-11-15T00:00:00.000+08",
                "description": "有機加工處理回覆表有缺漏"
            }
        ]
    },
    {
        "id": "7",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase": "changeReview",
        "activity": "changeReview_S40",
        "operatorNo": "1103",
        "operatorName": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "identityType": "individual",
        "formType": ["processing"],
        "certificationType": "processing",
        "region": "domestic",
        "type":  "change",
        "appNo": "202100028",
        "supplementItems": [
            {
                "id": "basicInfoChange",
                "description": "負責人電話為空號"
            },
            {
                "id": "storageChange",
                "description": "請重新上傳防治計畫"
            },
            {
                "id": "survey_3",
                "description": "有機完整性計畫缺少平行生產時的防止計畫"
            }
        ]
    },
    {
        "id": "8",
        "no": "1001",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase": "documentCheck",
        "activity": "documentCheck_S120",
        "operatorNo": "1103",
        "operatorName": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "identityType": "individual",
        "formType": ["processing"],
        "region": "domestic",
        "type":  "initial",
        "appNo": "202100024",
        "reviewResult": "reject",
        "reviewComments": "標章使用紀錄有缺漏，請再重新上傳正確的版本"
    }
]

export default certifications;